export const SkippedIcon = () => (
  <svg
    aria-hidden="true"
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clipPath="url(#clip0_2673_1719)">
      <path
        d="M10.0002 19.1673C15.0628 19.1673 19.1668 15.0633 19.1668 10.0007C19.1668 4.93804 15.0628 0.833984 10.0002 0.833984C4.93755 0.833984 0.833496 4.93804 0.833496 10.0007C0.833496 15.0633 4.93755 19.1673 10.0002 19.1673Z"
        fill="#1890FF"
        stroke="#1890FF"
        strokeWidth="1.33333"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M5 14.2411V6L10.1507 10.1206L5 14.2411Z"
        stroke="white"
        strokeWidth="1.05378"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M10.666 14.2411V6L15.8167 10.1206L10.666 14.2411Z"
        stroke="white"
        strokeWidth="1.05378"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </g>
    <defs>
      <clipPath id="clip0_2673_1719">
        <rect width="20" height="20" fill="white" />
      </clipPath>
    </defs>
  </svg>
)
